import { Layout } from 'antd';
import appointmentActions from 'features/appointment/services/actions';
import useTabletApp from 'hooks/useTabletApp';
import React, { useEffect } from 'react';
import { useAppDispatch } from 'store/hooks';
import BookingV4Sider from './components/BookingV4';
import ButtonViewFullStaff from './components/ButtonViewFullStaff';
import AppointmentCalendarV2 from './components/Calendar/v2';
import AppointmentCalendarHeaderV2 from './components/Calendar/v2/Header';
import ModalAnybody from './components/ModalAnybody';
import AppointmentsPageStyled from './styles';
import BookingV4 from './components/BookingV4';

type IAppointmentsPageProps = {
  public?: boolean;
};
const AppointmentsPage: React.FC<IAppointmentsPageProps> = ({ public: isPublic }) => {
  if (isPublic)
    useTabletApp(true);
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(appointmentActions.initData());
  }, []);

  return (
    <AppointmentsPageStyled>
      <Layout.Header style={headerStyle}>
        <AppointmentCalendarHeaderV2 />
      </Layout.Header>
      <Layout>
        <Layout.Content style={contentStyle}>
          <AppointmentCalendarV2 />
          <ButtonViewFullStaff />
        </Layout.Content>
        <BookingV4.Portal />
      </Layout>
      <ModalAnybody />
    </AppointmentsPageStyled>
  );
};

export default AppointmentsPage;

const headerStyle: React.CSSProperties = {
  height: 'auto',
  maxHeight: 'unset',
  paddingInline: 'unset',
  lineHeight: 'unset',
  background: 'transparent',
};

const contentStyle: React.CSSProperties = {
  position: 'relative',
};


const footerStyle: React.CSSProperties = {
  textAlign: 'center',
  color: '#fff',
  backgroundColor: '#4096ff',
};

const layoutStyle = {
  borderRadius: 8,
  overflow: 'hidden',
  width: 'calc(50% - 8px)',
  maxWidth: 'calc(50% - 8px)',
};
